import Nullstack from 'nullstack';
export default function IconCup({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cup",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 11h14v-3h-14z"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 11l-1.5 10h-8l-1.5 -10"
  }), "   ", Nullstack.element("path", {
    d: "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("path", {
    d: "M15 5v-2"
  }), " ");
}